// pages/resources/News.jsx
export default function News() {
  const news = [
    {
      title: "Adsurg Launches AI-Powered Campaign Optimizer",
      date: "February 8, 2026",
      category: "Product Launch",
      excerpt: "Revolutionary AI technology that automatically optimizes your campaigns in real-time for maximum performance and ROI"
    },
    {
      title: "Adsurg Reaches 10,000 Active Advertisers Milestone",
      date: "February 1, 2026",
      category: "Company News",
      excerpt: "We're proud to announce that we've reached 10,000 active advertisers across 50+ countries worldwide"
    },
    {
      title: "New Partnership with Major E-commerce Platforms",
      date: "January 25, 2026",
      category: "Partnership",
      excerpt: "Adsurg partners with leading e-commerce platforms to provide seamless integration and better tracking capabilities"
    },
    {
      title: "Q4 2025 Results: Record-Breaking Performance",
      date: "January 15, 2026",
      category: "Financial",
      excerpt: "Our clients achieved an average ROAS of 4.5:1 in Q4 2025, with total ad spend exceeding ₹100M"
    },
    {
      title: "Adsurg Wins 'Best Ad Tech Platform' Award",
      date: "December 20, 2025",
      category: "Award",
      excerpt: "Honored to receive the prestigious Digital Marketing Excellence Award for innovation in advertising technology"
    },
    {
      title: "New Office Opening in Singapore",
      date: "December 10, 2025",
      category: "Expansion",
      excerpt: "Expanding our presence in Southeast Asia with a new regional headquarters in Singapore"
    },
    {
      title: "Adsurg Introduces Video Ad Builder Tool",
      date: "November 28, 2025",
      category: "Product Launch",
      excerpt: "Create stunning video ads in minutes with our new drag-and-drop video ad builder featuring AI-powered templates"
    },
    {
      title: "Partnership with Google: Enhanced Integration",
      date: "November 15, 2025",
      category: "Partnership",
      excerpt: "Deeper integration with Google Ads API enables faster campaign deployment and better performance tracking"
    }
  ];

  return (
    <div className="min-h-screen bg-black pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl lg:text-6xl font-bold text-white mb-4">
            Latest News
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Stay updated with the latest announcements, product launches, and company news
          </p>
        </div>

        {/* Featured News */}
        <div className="mb-12">
          <div className="bg-gradient-to-br from-[#00809D]/20 via-gray-900 to-black border border-[#00809D]/50 rounded-3xl p-8 lg:p-12 hover:shadow-2xl hover:shadow-[#00809D]/30 transition-all duration-300">
            <span className="px-4 py-2 bg-[#00809D] text-white rounded-xl text-sm font-bold mb-4 inline-block">
              FEATURED
            </span>
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
              {news[0].title}
            </h2>
            <p className="text-gray-300 text-lg mb-6 leading-relaxed">
              {news[0].excerpt}
            </p>
            <div className="flex items-center gap-4 text-gray-400 text-sm mb-6">
              <span className="flex items-center gap-2">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                {news[0].date}
              </span>
              <span>•</span>
              <span className="px-3 py-1 bg-[#00809D]/20 text-[#00809D] rounded-full text-xs font-semibold">
                {news[0].category}
              </span>
            </div>
            <button className="bg-gradient-to-r from-[#00809D] to-[#00a0c4] text-white px-8 py-3 rounded-xl font-semibold hover:scale-105 transition-all shadow-lg shadow-[#00809D]/50">
              Read Full Story →
            </button>
          </div>
        </div>

        {/* News Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {news.slice(1).map((item, index) => (
            <article
              key={index}
              className="group bg-gradient-to-br from-gray-900 to-black border border-white/10 rounded-2xl p-6 hover:border-[#00809D]/50 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-[#00809D]/20"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="px-3 py-1 bg-[#00809D]/20 text-[#00809D] rounded-full text-xs font-semibold">
                  {item.category}
                </span>
                <span className="text-gray-500 text-sm">{item.date}</span>
              </div>

              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-[#00809D] transition-colors">
                {item.title}
              </h3>

              <p className="text-gray-400 mb-4 text-sm leading-relaxed">
                {item.excerpt}
              </p>

              <button className="text-[#00809D] font-semibold text-sm flex items-center gap-2 group-hover:gap-3 transition-all">
                Read More
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </button>
            </article>
          ))}
        </div>

        {/* Newsletter Subscription */}
        <div className="mt-16 bg-gradient-to-r from-gray-900 to-black border border-white/10 rounded-3xl p-8 lg:p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Never Miss an Update
          </h3>
          <p className="text-gray-400 mb-6 text-lg">
            Subscribe to our newsletter and get the latest news delivered to your inbox
          </p>
          <div className="max-w-md mx-auto flex gap-3">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 bg-black border border-white/20 rounded-xl px-4 py-3 text-white placeholder-gray-500 focus:border-[#00809D] focus:outline-none transition-colors"
            />
            <button className="bg-gradient-to-r from-[#00809D] to-[#00a0c4] text-white px-6 py-3 rounded-xl font-semibold hover:scale-105 transition-all shadow-lg shadow-[#00809D]/50 whitespace-nowrap">
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
